import { useMobileDetect } from "@/hooks";
import React from "react";
import { useEffect } from "react";

interface ChatRoomDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  isMessagesVisible: boolean;
  fullScreen?: boolean;
}

const ChatRoomDrawer = ({
  isOpen,
  onClose,
  children,
  fullScreen,
}: ChatRoomDrawerProps) => {
  const isMobile = useMobileDetect();

  // Function to add/remove 'overflow-hidden' class from the body
  const toggleBodyOverflow = (isOpen: boolean) => {
    const body = document.querySelector("body");
    if (body) {
      body.classList.toggle("overflow-auto", isOpen);
    }
  };

  useEffect(() => {
    toggleBodyOverflow(isOpen); // Call the function when the drawer opens/closes
    return () => toggleBodyOverflow(false); // Reset body overflow when component unmounts
  }, [isOpen]);

  return (
    <div
      className={`${fullScreen ? "h-[100vh] w-full" : !isMobile ? "fixed bottom-[96px] right-0" : "fixed bottom-[105px] right-0 h-[70vh]"} z-50 transform border border-white/10 transition-transform sm:top-20 lg:bottom-0 ${
        isOpen ? "" : "hidden"
      }`}
    >
      <div className="h-full">{children}</div>
    </div>
  );
};

export default ChatRoomDrawer;
